import React, {Component} from 'react'

import ScrollerMobileComponent from './ScrollerMobile.component'

import {
  ScrollMobile
} from './Scroller.styles'

class ScrollerMobile extends Component {
  constructor(props) {
    super(props)

    this.headers = props.headers.slice()
    this.headers.shift()

    this.totalWidth = this.headers.reduce((prev, curr) => {
      return prev + curr.width
    }, 0) - this.headers[this.headers.length - 1].width

    this.state = {}

    this.currCol = 0
  }

  componentDidMount() {
    this.props.setOffset(0)
  }

    handleScrollDotClick = (dotNumber) => {
      if (this.currCol === dotNumber) {
        return false
      }

      this.currCol = dotNumber

      this.props.setOffset(this.getColumnOffsetFromPosition(this.currCol))

      this.props.analytics.propagateEvent({
        eventType: 'click',
        action: 'Mobile Scroll Dot: ' + this.currCol,
        type: 'Datatable'
      })
    }

    handleScrollLeftClick = () => {
      if (this.currCol === 0) {
        return false
      }

      this.currCol = this.currCol - 1

      this.props.setOffset(this.getColumnOffsetFromPosition(this.currCol))

      this.props.analytics.propagateEvent({
        eventType: 'click',
        action: 'Mobile Scroll Left',
        type: 'Datatable'
      })
    }

    handleScrollRightClick = () => {
      let length = this.headers.length

      if (this.props.rowActions) {
        length += 1
      }

      if (this.currCol === length - 1) {
        return false
      }

      this.currCol = this.currCol + 1

      this.props.setOffset(this.getColumnOffsetFromPosition(this.currCol))

      this.props.analytics.propagateEvent({
        eventType: 'click',
        action: 'Mobile Scroll Right',
        type: 'Datatable'
      })
    }

    getColumnOffsetFromPosition(position) {
      let offset = 0

      for (let i = 0; i < position; i++) {
        offset += this.headers[i].width + 12
      }

      return offset
    }

    render() {
      const events = {
        handleScrollLeftClick: this.handleScrollLeftClick,
        handleScrollRightClick: this.handleScrollRightClick,
        handleScrollDotClick: this.handleScrollDotClick
      }

      const {headers} = this.props

      return (
        <ScrollMobile events={events}>
          <ScrollerMobileComponent events={events} currCol={this.currCol} scrollHandle={this.props.scrollHandle} headers={headers} />
        </ScrollMobile>
      )
    }
}

export default ScrollerMobile
